import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "./pages/Dashboard";
import AssetDetail from "./pages/AssetDetail";
import SIPCalculator from "./pages/SIPCalculator";
import MutualFundRecommender from "./pages/MutualFundRecommender";
import NewsDashboard from "./pages/NewsDashboard";
import WatchesDashboard from "./pages/WatchesDashboard";
import InsightsList from "./pages/InsightsList";
import InsightDetail from "./pages/InsightDetail";
import Screener from "./pages/Screener";
import { SectorsIndex, SectorDetail } from "./pages/Sectors";
import Compare from "./pages/Compare";
import PWAInstallPrompt from "./components/PWAInstallPrompt";

// Suppress noisy TradingView cross-origin script errors that bubble up
// without affecting our app. These come from the embedded widget.
if (typeof window !== "undefined") {
  const swallow = (e) => {
    const msg = (e?.message || "") + " " + (e?.error?.stack || "") + " " + (e?.filename || "");
    if (
      msg.includes("Script error") ||
      msg.includes("querySelector") ||
      msg.includes("tradingview") ||
      msg.includes("tv-embed")
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  };
  window.addEventListener("error", swallow, true);
  window.addEventListener("unhandledrejection", (e) => {
    const msg = String(e?.reason || "");
    if (msg.includes("tradingview") || msg.includes("Script error") || msg.includes("querySelector")) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
  // Override window.onerror used by CRA overlay
  window.onerror = function (message, source, lineno, colno, error) {
    const m = String(message || "") + " " + String(source || "");
    if (m.includes("Script error") || m.includes("querySelector") || m.includes("tradingview")) {
      return true; // suppress
    }
    return false;
  };
}

function App() {
  useEffect(() => {}, []);
  return (
    <HelmetProvider>
      <div className="App font-sans">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/asset/:symbol" element={<AssetDetail />} />
            <Route path="/sip" element={<SIPCalculator />} />
            <Route path="/funds" element={<MutualFundRecommender />} />
            <Route path="/news" element={<NewsDashboard />} />
            <Route path="/watches" element={<WatchesDashboard />} />
            <Route path="/insights" element={<InsightsList />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
            <Route path="/most-bullish" element={<Screener defaultDirection="bullish" />} />
            <Route path="/most-bearish" element={<Screener defaultDirection="bearish" />} />
            <Route path="/movers" element={<Screener />} />
            <Route path="/movers/:region" element={<Screener />} />
            <Route path="/sectors" element={<SectorsIndex />} />
            <Route path="/sector/:slug" element={<SectorDetail />} />
            <Route path="/compare/:a/:b" element={<Compare />} />
            <Route path="/compare/:pair" element={<Compare />} />
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </BrowserRouter>
        <PWAInstallPrompt />
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: "2px",
              color: "#fff",
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
